export function collectValidationMessages(errors) {
  if (!errors) {
    return [];
  }

  if (typeof errors.all === 'function') {
    return errors.all().filter(Boolean);
  }

  if (Array.isArray(errors.items)) {
    return errors.items.map((item) => item.msg).filter(Boolean);
  }

  return [];
}

export function buildValidationAnnouncement(
  errors,
  prefix = 'Please correct the following errors.'
) {
  const messages = collectValidationMessages(errors);
  if (!messages.length) {
    return '';
  }

  return `${prefix} ${messages.join('. ')}`;
}

export function announceValidationErrorsViaStatus(vm, statusKey, errors, options = {}) {
  const text = buildValidationAnnouncement(errors, options.prefix);
  if (!text || !vm) {
    return;
  }

  vm[statusKey] = '';
  vm.$nextTick(() => {
    vm[statusKey] = text;
  });
}



// WEBPACK FOOTER //
// ./src/utils/formValidationAnnounce.js